module.exports = __webpack_public_path__ + "static/media/Bell.42fb99f6.png";